module.exports = __webpack_public_path__ + "static/media/sulphites.96481160.svg";